export default "__VITE_ASSET__BM8dMtrb__"